import { push } from "connected-react-router";

import {
  getMessageInfo,
  deleteMessage,
} from '../../request';

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, showSuccessMessage, closeDeleteMessageModal } from "./ui";

//Загрузка информации о сообщении
export const MESSAGE_INFO_LOADING_START = "Message info loading start";
export const MESSAGE_INFO_LOADED_SUCCESSFULLY = "Message info loaded successfully";
export const MESSAGE_INFO_LOADING_FAILED = "Failure during message info load";

//Удаление сообщения
export const MESSAGE_DELETION_START = "Message deletion start";
export const MESSAGE_DELETED_SUCCESSFULLY = "Message deleted successfully";
export const MESSAGE_DELETION_FAILED = "Failure during message deletion";

const startLoading = () => ({
  type: MESSAGE_INFO_LOADING_START 
});

const loadSuccess = message => ({
  type: MESSAGE_INFO_LOADED_SUCCESSFULLY,
  payload: {
    message: message || {}
  }
});

const loadFailure = () => ({
  type: MESSAGE_INFO_LOADING_FAILED,
});

//ЗАГРУЗКА ИНФОРМАЦИИ О СООБЩЕНИИ
export const getMessageInfoAsync = msgId => { 
  return async (dispatch) => {
    dispatch(startLoading());
    await dispatch(checkAndRenewTokens());
    let message;
    const accessToken = localStorage.getItem("accessToken");
    try {
      message = await getMessageInfo(accessToken, msgId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке сообщения!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(message));
  };
};

//УДАЛЕНИЕ СООБЩЕНИЯ
const startDeletion = () => ({
  type: MESSAGE_DELETION_START
});

const deletionSuccess = () => ({
  type: MESSAGE_DELETED_SUCCESSFULLY,
});

const deletionFailure = () => ({
  type: MESSAGE_DELETION_FAILED,
});

export const deleteMessageAsync = msgId => { 
  return async (dispatch, getState) => {
    dispatch(startDeletion());
    await dispatch(checkAndRenewTokens());
    //Получим название сообщения
    const currentState = getState();
    const messageName = currentState.messageInfo.message.title;
    try {
      const accessToken = localStorage.getItem("accessToken");
      await deleteMessage(accessToken, msgId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при удалении сообщения!"));
      return dispatch(deletionFailure());
    }
    dispatch(push('/messages'));
    dispatch(closeDeleteMessageModal());
    const msgText = `Сообщение ${messageName} удалено`;
    dispatch(showSuccessMessage(msgText));
    return dispatch(deletionSuccess());
  };
};
